export const summaryMetrics = {
  totalEmissions: 24582.4,
  unit: 'tCO2e',
  trend: -5.2,
  scopes: [
    { id: 'scope1', name: 'Scope 1 (Direct)', value: 4250.1, color: '#10b981', trend: -2.1 },
    { id: 'scope2', name: 'Scope 2 (Indirect)', value: 8320.5, color: '#06b6d4', trend: -8.4 },
    { id: 'scope3', name: 'Scope 3 (Value Chain)', value: 12011.8, color: '#3b82f6', trend: -4.0 }
  ]
};

export const monthlyEmissionsData = {
  months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  scope1: [350, 340, 360, 320, 310, 350, 380, 370, 350, 340, 360, 380],
  scope2: [700, 680, 720, 650, 610, 690, 750, 730, 690, 680, 700, 720],
  scope3: [1000, 980, 1050, 950, 900, 1020, 1100, 1080, 1000, 980, 1020, 1050]
};

export const suppliers = [
  { id: 'SUP-001', name: 'Global Logistics Inc.', category: 'Transportation', status: 'Verified', emissions: 4520.5, risk: 'Low' },
  { id: 'SUP-002', name: 'TechHardware Corp', category: 'Procurement', status: 'Pending', emissions: 2100.0, risk: 'Medium' },
  { id: 'SUP-003', name: 'EcoPack Materials', category: 'Packaging', status: 'Verified', emissions: 850.2, risk: 'Low' },
  { id: 'SUP-004', name: 'CloudServe AWS', category: 'IT Services', status: 'Verified', emissions: 1240.8, risk: 'Low' },
  { id: 'SUP-005', name: 'Apex Manufacturing', category: 'Raw Materials', status: 'Action Required', emissions: 5600.0, risk: 'High' },
];

export const initiatives = [
  { id: 'INT-1', title: 'Solar Panel Installation (HQ)', category: 'Scope 2', status: 'In Progress', progress: 65, expectedReduction: 450 },
  { id: 'INT-2', title: 'Fleet Electrification Phase 1', category: 'Scope 1', status: 'Planning', progress: 15, expectedReduction: 820 },
  { id: 'INT-3', title: 'Supplier Code of Conduct Revamp', category: 'Scope 3', status: 'Completed', progress: 100, expectedReduction: 1200 },
  { id: 'INT-4', title: 'HVAC Optimization', category: 'Scope 2', status: 'In Progress', progress: 40, expectedReduction: 180 },
];

export const reportChecklist = [
  { id: 1, task: 'Verify Q3 Energy Bills', completed: true },
  { id: 2, task: 'Collect Scope 3 Travel Data', completed: true },
  { id: 3, task: 'Audit Supplier Emissions Factors', completed: false },
  { id: 4, task: 'Draft Executive Summary', completed: false },
  { id: 5, task: 'Finalize Board Presentation', completed: false },
];